(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-bam-cart-drop]';
  var LINES_SELECTOR = '[data-bam-cart-lines]';
  var PENDING_KEY = 'bam.bundleCart.pendingRemoval.v1';
  var NOTICE_KEY = 'bam.bundleCart.activeNotice.v1';
  var MAX_AGE = 5 * 60 * 1000;
  var activeNotice = readStored(NOTICE_KEY);
  var syncTimer = null;

  function readStored(key) {
    try {
      var value = window.sessionStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function writeStored(key, value) {
    try {
      if (value === null) {
        window.sessionStorage.removeItem(key);
      } else {
        window.sessionStorage.setItem(key, JSON.stringify(value));
      }
    } catch (error) {
      // The notice still works for Ajax updates when storage is unavailable.
    }
  }

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR));
  }

  function eligibleQuantity(root) {
    var value = parseInt(root.getAttribute('data-eligible-quantity'), 10);
    return isNaN(value) ? 0 : value;
  }

  function lines(root) {
    var source = root.querySelector(LINES_SELECTOR);
    if (!source) return [];

    try {
      var parsed = JSON.parse(source.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function lineForAction(action, root) {
    var key = action.getAttribute('data-item-key');
    var row = action.closest ? action.closest('.ajax-cart__cart-item') : null;
    var input = row ? row.querySelector('[data-item-key]') : null;
    if (!key && input) key = input.getAttribute('data-item-key');

    var variantId = action.getAttribute('data-item-id') ||
      action.getAttribute('data-ajax-qty-decrease') ||
      (input ? input.getAttribute('data-item-id') : null);

    return lines(root).filter(function (item) {
      if (key) return item.key === key;
      return String(item.variant_id) === String(variantId);
    })[0] || null;
  }

  function rememberRemoval(action, removalQuantity) {
    var form = action.closest ? action.closest('.js-cart-form') : null;
    var root = form ? form.querySelector(ROOT_SELECTOR) : document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    var item = lineForAction(action, root);
    if (!item || !item.eligible) return;

    var quantity = Math.max(1, parseInt(removalQuantity, 10) || 1);
    var pending = {
      before: eligibleQuantity(root),
      removed: Math.min(quantity, item.quantity),
      variant_id: item.variant_id,
      properties: item.properties || {},
      selling_plan: item.selling_plan || null,
      created_at: Date.now()
    };

    writeStored(PENDING_KEY, pending);
  }

  function crossedTier(before, after) {
    var thresholds = [4, 3, 2];
    for (var i = 0; i < thresholds.length; i += 1) {
      if (before >= thresholds[i] && after < thresholds[i]) return thresholds[i];
    }
    return 0;
  }

  function messageForTier(tier, restoreQuantity) {
    var addBack = restoreQuantity === 1 ? 'Add one back?' : 'Add ' + restoreQuantity + ' back?';
    if (tier === 4) return 'You dropped below 4 items and lost your 25%. ' + addBack;
    if (tier === 3) return 'You dropped below 3 items and lost your 15%. ' + addBack;
    return 'You dropped below 2 items. Free shipping still depends on the $65 store rule. ' + addBack;
  }

  function buildNotice(pending, currentQuantity, tier) {
    var restoreQuantity = Math.max(1, tier - currentQuantity);
    restoreQuantity = Math.min(restoreQuantity, pending.removed || restoreQuantity);

    return {
      tier: tier,
      after: currentQuantity,
      message: messageForTier(tier, restoreQuantity),
      variant_id: pending.variant_id || null,
      properties: pending.properties || {},
      selling_plan: pending.selling_plan || null,
      restore_quantity: restoreQuantity,
      created_at: Date.now()
    };
  }

  function clearNotice() {
    activeNotice = null;
    writeStored(NOTICE_KEY, null);
    roots().forEach(function (root) {
      root.hidden = true;
    });
  }

  function renderNotice(root, notice) {
    var message = root.querySelector('[data-bam-cart-drop-message]');
    var restore = root.querySelector('[data-bam-cart-drop-restore]');
    var builder = root.querySelector('[data-bam-cart-drop-builder]');
    var builderUrl = root.getAttribute('data-builder-url') || '/pages/build-your-bundle';

    if (message) message.textContent = notice.message;

    if (restore && notice.variant_id) {
      var quantity = notice.restore_quantity || 1;
      restore.textContent = quantity === 1 ? 'Add one back' : 'Add ' + quantity + ' back';
      restore.hidden = false;
      restore.disabled = false;
    } else if (restore) {
      restore.hidden = true;
    }

    if (builder) {
      builder.href = builderUrl;
      builder.hidden = Boolean(notice.variant_id);
    }

    root.hidden = false;
  }

  function sync() {
    var allRoots = roots();
    if (!allRoots.length) return;

    var currentQuantity = eligibleQuantity(allRoots[0]);
    var pending = readStored(PENDING_KEY);

    if (pending && Date.now() - pending.created_at > MAX_AGE) {
      pending = null;
      writeStored(PENDING_KEY, null);
    }

    if (pending && currentQuantity < pending.before) {
      var tier = crossedTier(pending.before, currentQuantity);
      writeStored(PENDING_KEY, null);

      if (tier) {
        activeNotice = buildNotice(pending, currentQuantity, tier);
        writeStored(NOTICE_KEY, activeNotice);
      } else {
        clearNotice();
      }
    }

    if (pending && currentQuantity > pending.before) {
      writeStored(PENDING_KEY, null);
    }

    if (activeNotice && Date.now() - activeNotice.created_at > MAX_AGE) {
      clearNotice();
      return;
    }

    if (activeNotice && currentQuantity >= activeNotice.tier) {
      clearNotice();
      return;
    }

    if (!activeNotice) {
      allRoots.forEach(function (root) { root.hidden = true; });
      return;
    }

    allRoots.forEach(function (root) {
      renderNotice(root, activeNotice);
    });
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(sync, 20);
  }

  function refreshThemeCart(root) {
    var shopify = window.Shopify;
    var ajaxCart = shopify && shopify.theme && shopify.theme.ajaxCart;
    var cartApi = shopify && shopify.theme && shopify.theme.cart;
    var configElement = document.getElementById('cart-config');

    if (ajaxCart && cartApi && typeof cartApi.getCart === 'function' &&
        typeof ajaxCart.updateView === 'function' && configElement) {
      var config;
      try {
        config = JSON.parse(configElement.textContent || '{}');
      } catch (error) {
        config = null;
      }

      if (config) {
        return cartApi.getCart().then(function (cart) {
          ajaxCart.updateView(config, cart);
        });
      }
    }

    window.location.assign(root && root.getAttribute('data-cart-url') || '/cart');
    return Promise.resolve();
  }

  function restoreItem(button) {
    if (!activeNotice || !activeNotice.variant_id || button.disabled) return;

    button.disabled = true;
    button.textContent = 'Adding...';

    var item = {
      id: activeNotice.variant_id,
      quantity: activeNotice.restore_quantity || 1
    };
    if (activeNotice.properties && Object.keys(activeNotice.properties).length) {
      item.properties = activeNotice.properties;
    }
    if (activeNotice.selling_plan) item.selling_plan = activeNotice.selling_plan;

    var root = button.closest ? button.closest(ROOT_SELECTOR) : null;
    var addUrl = root && root.getAttribute('data-cart-add-url') || '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: [item] })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    }).then(function () {
      clearNotice();
      writeStored(PENDING_KEY, null);
      return refreshThemeCart(root);
    }).catch(function () {
      button.disabled = false;
      button.textContent = 'Retry add';
      roots().forEach(function (root) {
        var message = root.querySelector('[data-bam-cart-drop-message]');
        if (message) message.textContent = 'That item could not be added back. Try again or choose another item.';
      });
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var restore = target.closest('[data-bam-cart-drop-restore]');
    if (restore) {
      event.preventDefault();
      restoreItem(restore);
      return;
    }

    var dismiss = target.closest('[data-bam-cart-drop-dismiss]');
    if (dismiss) {
      event.preventDefault();
      clearNotice();
      return;
    }

    var remove = target.closest('.js-cart-remove');
    if (remove) {
      var removeRoot = remove.closest('.js-cart-form');
      var removeNotice = removeRoot ? removeRoot.querySelector(ROOT_SELECTOR) : document.querySelector(ROOT_SELECTOR);
      var removeLine = removeNotice ? lineForAction(remove, removeNotice) : null;
      rememberRemoval(remove, removeLine ? removeLine.quantity : 1);
      return;
    }

    var decrease = target.closest('[data-ajax-qty-decrease]');
    if (decrease) rememberRemoval(decrease, 1);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target || !event.target.closest) return;
    var decrease = event.target.closest('[data-ajax-qty-decrease]');
    if (decrease) rememberRemoval(decrease, 1);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-item-qty]')) return;

    var form = input.closest('.js-cart-form');
    var root = form ? form.querySelector(ROOT_SELECTOR) : document.querySelector(ROOT_SELECTOR);
    var item = root ? lineForAction(input, root) : null;
    var nextQuantity = Math.max(0, parseInt(input.value, 10) || 0);

    if (item && nextQuantity < item.quantity) {
      rememberRemoval(input, item.quantity - nextQuantity);
    }
  }, true);

  var observer = new MutationObserver(function (mutations) {
    var hasNewCartMarkup = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        if (!node || node.nodeType !== 1) return false;
        return (node.matches && node.matches(ROOT_SELECTOR)) ||
          (node.querySelector && node.querySelector(ROOT_SELECTOR));
      });
    });

    if (hasNewCartMarkup) scheduleSync();
  });

  function init() {
    sync();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
